import { graphql } from "@/gql";

export const createWorkOrderDriver = graphql(`
  mutation CreateWorkOrderDriverMutation($input: CreateWorkOrderDriverInput!) {
    createWorkOrderAssignment(input: $input) {
      id
    }
  }
`);

export const updateWorkOrderAssignment = graphql(`
  mutation UpdateWorkOrderAssignmentMutation(
    $id: ID!
    $input: UpdateWorkOrderAssignmentInput!
  ) {
    updateWorkOrderAssignment(id: $id, input: $input) {
      id
      status
      pickup_date
      pickup_time
      delivery_date
      delivery_time
      booking_reference
      driver_notes
    }
  }
`);

export const deleteWorkOrderDriver = graphql(`
  mutation DeleteWorkOrderDriverMutation($id: ID!) {
    deleteWorkOrderAssignment(id: $id) {
      id
    }
  }
`);

export const markPickedUpWorkOrderAssignment = graphql(`
  mutation MarkPickedUpWorkOrderAssignmentMutation($id: ID!) {
    markPickedUpWorkOrderAssignment(id: $id) {
      id
      status
    }
  }
`);

export const markDeliveredWorkOrderAssignment = graphql(`
  mutation MarkDeliveredWorkOrderAssignmentMutation($id: ID!) {
    markDeliveredWorkOrderAssignment(id: $id) {
      id
      status
    }
  }
`);

export const markReceiptsUploadedWorkOrderAssignment = graphql(`
  mutation MarkReceiptsUploadedWorkOrderAssignmentMutation($id: ID!) {
    markReceiptsUploadedWorkOrderAssignment(id: $id) {
      id
      status
    }
  }
`);

export const approveReceiptsWorkOrderAssignment = graphql(`
  mutation ApproveReceiptsWorkOrderAssignmentMutation($id: ID!) {
    approveReceiptsWorkOrderAssignment(id: $id) {
      id
      status
    }
  }
`);

export const markCompletedWorkOrderAssignment = graphql(`
  mutation MarkCompletedWorkOrderAssignmentMutation($id: ID!) {
    markCompletedWorkOrderAssignment(id: $id) {
      id
      status
    }
  }
`);

export const resetWorkOrderAssignment = graphql(`
  mutation ResetWorkOrderAssignmentMutation($id: ID!) {
    resetWorkOrderAssignment(id: $id) {
      id
      status
    }
  }
`);

export const createProDriverReview = graphql(`
  mutation CreateProDriverReview($input: CreateWorkOrderDriverReviewInput!) {
    createProDriverReview(input: $input) {
      id
    }
  }
`);
